import { Grid2 } from "@mui/material";

import { useGetForecast } from "api";
import { Widget } from "components/elements/mui";
import { useFormatMessage } from "lang";
import { FORECAST } from "routes/consts";

import { ForecastEnergy } from "./components/ForecastEnergy";
import { ForecastWeather } from "./components/ForecastWeather";

export const Forecast = () => {
  const formatMessage = useFormatMessage();
  const FIVE_MINUTES = 5 * 60 * 1000;

  const { data, isLoading } = useGetForecast({
    request: {
      limited: true,
    },
    options: {
      refetchInterval: FIVE_MINUTES,
      refetchOnWindowFocus: true,
      staleTime: FIVE_MINUTES,
    },
  });

  return (
    <Widget
      title={formatMessage("pageTitle.forecast")}
      icon={"insights"}
      content={
        <Grid2 container spacing={2}>
          <ForecastWeather data={data} isLoading={isLoading} />
          <ForecastEnergy data={data} isLoading={isLoading} />
        </Grid2>
      }
      url={`${FORECAST}?param=energy`}
      size={{ xs: 12 }}
    />
  );
};
